<script setup>

import {computed} from "vue";
import {store} from "@/store";

const props = defineProps({
  value: Number,
  type: String
})
const valueString = computed(() => {
  return (props.value === 0) ? 'Add +' : `£${props.value.toLocaleString()} per annum`;
})
</script>

<template>
  <tr>
    <td>
      <span class="st__cell st__label"><slot></slot></span>
    </td>
    <td>
      <span v-on:click="store.formState.addSavingType = props.type; store.formState.modal = 'addSaving'"
            class="st__cell st__value">{{ valueString }}</span>
    </td>
  </tr>
</template>
